import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import {
    Box,
    Container,
    Divider,
    Link,
    Paper,
    Typography,
} from '@mui/material';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useLogger } from '../../hooks/useLogger';

const SUPPORT_EMAIL = 'support@hustro.com';

export const FormArchivedPage = () => {
    const intl = useIntl();
    const logger = useLogger();

    useEffect(() => {
        logger.warn('Form archived page was displayed to the user');
    }, [logger]);

    return (
        <Box
            sx={{
                boxSizing: 'border-box',
                minHeight: {
                    xs: 'calc(100vh - 56px)',
                    sm: 'calc(100vh - 64px)',
                },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
            }}
        >
            <Container maxWidth="sm">
                <Paper
                    elevation={3}
                    sx={{
                        p: { xs: 3, sm: 5 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2.5,
                    }}
                >
                    <Box
                        sx={{
                            width: 72,
                            height: 72,
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'warning.light',
                            color: 'warning.contrastText',
                        }}
                    >
                        <Inventory2OutlinedIcon sx={{ fontSize: 40 }} />
                    </Box>

                    <Typography
                        variant="h5"
                        component="h1"
                        align="center"
                        fontWeight={600}
                    >
                        {intl.formatMessage({
                            id: 'simple_form_archived_title',
                        })}
                    </Typography>

                    <Typography
                        variant="body1"
                        color="text.secondary"
                        align="center"
                    >
                        {intl.formatMessage({
                            id: 'simple_form_archived_message',
                        })}
                    </Typography>

                    <Divider flexItem sx={{ mt: 1 }} />

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        align="center"
                    >
                        {intl.formatMessage(
                            { id: 'simple_form_archived_support' },
                            {
                                supportLink: (
                                    <Link
                                        href={`mailto:${SUPPORT_EMAIL}`}
                                        color="secondary"
                                        underline="always"
                                    >
                                        {SUPPORT_EMAIL}
                                    </Link>
                                ),
                            },
                        )}
                    </Typography>
                </Paper>
            </Container>
        </Box>
    );
};
